import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import EnvWindow from './env';

export const initTranslations = async (namespace: string | string[], debug = false) => {
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      initImmediate: false,
      backend: {
        loadPath: `${EnvWindow.REACT_APP_ADMIN__LABELS_URL}/{{ns}}`,
      },
      ns: namespace,
      debug,
      lng: 'pl',
      fallbackLng: false,
      interpolation: {
        escapeValue: false,
      },
    });
};

export const addTranslations = async (namespace: string | string[]) => {
  i18n.loadNamespaces(namespace);
};
